import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../../shared/utils/api.js'

export const fetchCustomers = createAsyncThunk('customers/fetch', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get(`/v1/buyers`)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message)
  }
})

export const fetchSingleCustomer = createAsyncThunk('customer/fetch', async (customerId, { rejectWithValue }) => {
  try {
    const response = await api.get(`/v1/admin/buyers/${customerId}`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message)
  }
})

export const createCustomer = createAsyncThunk('customer/create', async (buyerData, { rejectWithValue }) => {
  try {
    const response = await api.post('/v1/auth/buyer/signup', buyerData)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message)
  }
})

export const blockCustomer = createAsyncThunk('customer/block', async (customerId, { rejectWithValue }) => {
  try {
    const response = await api.post(`/v1/auth/buyer/block/${customerId}`)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message)
  }
})

export const deactivateCustomer = createAsyncThunk('customer/unblock', async (customerId, { rejectWithValue }) => {
  try {
    const response = await api.post(`/v1/auth/buyer/deactivate/${customerId}`)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message)
  }
})
